import { Injectable } from '@angular/core';

export interface SubMenu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
}
export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
  children: SubMenu[];
}

const MENUITEMS = [

  { state: 'passagerlist/create', type: 'link', name: 'ajoutePassager', icon: 'person_add' , priv: 'cr_passager', children: []},
  { state: 'reservation', type: 'link', name: 'reservationList', icon: 'perm_contact_calendar' , priv: 'rd_reservation', children: []},
  { state: 'passagerlist', type: 'link', name: 'passagerList', icon: 'groups', priv: 'rd_passager', children: [] },
  { state: 'session\/usersession', type: 'link', name: 'raportsessions', icon: 'insights' , priv: 'cr_passager', children: []},
];

@Injectable()
export class MenuItemsGuichet {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
